import team from './team';
import services from './services';
import portfolio from './portfolio';
import speakers from './speakers';
import schedule from './schedule';
import products from './products';
import blogs from './blogs';



const navbar = [
  {
      id: 1,
      mainLink : {link: '/', title: 'home'},
      subLink: [],
  },
  {
      id: 2,
      mainLink : {link: '#', title: 'about'},
      subLink: [
          {id: 1, link: '/About-us', title: 'about us'},
          {id: 2, link: '/Team', title: 'team'},
          {id: 3, link: '/Team/TeamSingle', title: 'team single', state: team[0]},
          {id: 4, link: '/Testimonials', title: 'testimonials'},
          {id: 5, link: '/Faqs', title: 'faqs'},
      ],
  },
  {
      id: 3,
      mainLink: { title: "Pages", link: "#" },
      subLink: [
        { id: 1, link: "/Gallery", title: "Gallery"  },
        { id: 2, link: "/Portfolio", title: "Portfolio" },
        { id: 3, link: "/Portfolio/Portfolio-Single", title: "Portfolio Single",  state: portfolio[0] },
        { id: 4, link: "/Services", title: "Services" },
        { id: 5, link: "/Services/Service-Single", title: "Service Single",  state: services[0] },
        { id: 6, link: "/Tickets", title: "Buy Tickets" },
        { id: 7, link: "/Registration", title: "Registration" },
        { id: 8, link: "/Sponsors", title: "Sponsors" },
        { id: 9, link: "/Venue", title: "Venue" },
      ],
  },
  {
    id: 4,
    mainLink : {link: '#', title: 'Speaker'},
    subLink: [
        {id: 1, link: '/Speakers', title: 'Speakers'},
        {id: 2, link: '/Speakers/Speaker-Single', title: 'Speaker single', state: speakers[0]}, 
    ],
  },
  {
      id: 5, 
      mainLink : {link: '#', title: 'Schedule'},
      subLink: [
        { id: 1, link: "/ScheduleTab", title: "Schedule Tab" },
        { id: 2, link: "/ScheduleList", title: "Schedule List" },
        { id: 3, link: "/ScheduleEvent", title: "Schedule Event" },
        { id: 4, link: "/Schedule/Schedule-Single", title: "Schedule Single", state: schedule[0] },
      ],
  }, 
  {
      id: 6,
      mainLink : {link: '#', title: 'blog'},
      subLink: [
          {id: 1, link: '/Blog-grid', title: 'blog grid'},
          {id: 2, link: '/Blog-list', title: 'blog list'},
          {id: 3, link: '/Blogs/Blog-Single', title: 'blog single', state: blogs[0]},
      ],
  },
  {
      id: 7,
      mainLink : {link: '#', title: 'shop'},
      subLink: [
          {id: 1, link: '/Shop-grid', title: 'shop grid'},
          {id: 2, link: '/Shop-list', title: 'shop list'},
          {id: 3, link: '/Shop/Product-Single', title: 'product single', state: products[0]},
          {id: 4, link: '/Wishlist', title: 'wishlist'},
          {id: 5, link: '/Cart', title: 'cart'},
          {id: 6, link: '/Checkout', title: 'checkout'},
          {id: 7, link: '/OrderConfirmation', title: 'Order Confirmation'},
          {id: 8, link: '/Login', title: 'login'},
          {id: 9, link: '/Register', title: 'register'},
          {id: 10, link: '/Forgot-pwd', title: 'forgot Password'},
      ],
  },
  {
      id: 8,
      mainLink : {link: '/Contact-us', title: 'contact'},
      subLink: [],
  },
];

export default navbar;